import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  Flex,
  Icon,
  Badge,
  Card,
  CardBody,
  useColorMode,
} from "@chakra-ui/react";
import { FaVideo, FaCoins, FaExternalLinkAlt } from "react-icons/fa";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor } from "../../brandConfig";

// TODO: Replace with actual Zoom link from event config
const ZOOM_LINK = "https://zoom.us/j/YOUR_MEETING_ID";

const LivePage = () => {
  const { colorMode } = useColorMode();

  const bg = getColor("background.main", colorMode);
  const textPrimary = colorMode === "light" ? "gray.800" : "white";
  const textSecondary = colorMode === "light" ? "gray.600" : "gray.300";

  return (
    <Box bg={bg} minHeight="100vh">
      <NavbarWithCallToAction />

      <Container maxW="900px" py={16}>
        <VStack spacing={8} textAlign="center">
          <Badge
            bg="linear-gradient(135deg, #EF4444 0%, #DC2626 100%)"
            color="white"
            fontSize="lg"
            px={6}
            py={2}
            borderRadius="full"
            fontWeight="700"
            boxShadow="0 4px 16px rgba(239, 68, 68, 0.4)"
            animation="pulse 2s infinite"
          >
            <Icon as={FaVideo} mr={2} />
            LIVE NOW
          </Badge>

          <Heading
            as="h1"
            fontSize={{ base: "2xl", md: "4xl" }}
            fontWeight="800"
            color={textPrimary}
          >
            Business Sovereignty Webinar
          </Heading>

          <Text fontSize="lg" color={textSecondary} maxW="600px">
            The session is live! Click below to join on Zoom.
          </Text>

          {/* Zoom Join */}
          <Card
            bg="linear-gradient(135deg, rgba(147, 51, 234, 0.1) 0%, rgba(79, 70, 229, 0.1) 100%)"
            borderWidth="3px"
            borderColor="rgba(147, 51, 234, 0.5)"
            borderRadius="2xl"
            boxShadow="0 12px 40px rgba(147, 51, 234, 0.3)"
            w="100%"
            maxW="600px"
          >
            <CardBody p={10} textAlign="center">
              <Icon as={FaVideo} w={16} h={16} color="#9333EA" mb={4} />
              <Heading size="lg" color={textPrimary} mb={4}>
                Join the Live Session
              </Heading>
              <Button
                as="a"
                href={ZOOM_LINK}
                target="_blank"
                rel="noopener noreferrer"
                size="lg"
                bg="linear-gradient(135deg, #9333EA 0%, #7C3AED 100%)"
                color="white"
                rightIcon={<Icon as={FaExternalLinkAlt} />}
                _hover={{
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 24px rgba(147, 51, 234, 0.5)",
                }}
                px={12}
                py={7}
                fontSize="xl"
              >
                Join on Zoom
              </Button>
              <Text fontSize="sm" color={textSecondary} mt={4}>
                Having trouble? Contact us at tom@tommillerservices.com
              </Text>
            </CardBody>
          </Card>

          {/* Token reminder */}
          <Card
            bg="rgba(245, 158, 11, 0.1)"
            borderWidth="1px"
            borderColor="rgba(245, 158, 11, 0.3)"
            borderRadius="xl"
            w="100%"
            maxW="600px"
          >
            <CardBody>
              <Flex align="center" justify="center" gap={3}>
                <Icon as={FaCoins} w={6} h={6} color="#F59E0B" />
                <Box textAlign="left">
                  <Text fontWeight="700" color={textPrimary} fontSize="md">
                    Earn BB Tokens During This Webinar
                  </Text>
                  <Text fontSize="sm" color={textSecondary}>
                    +1 token for attending live, +1 for staying till the end.
                    That's AU$100 in rewards!
                  </Text>
                </Box>
              </Flex>
            </CardBody>
          </Card>
        </VStack>
      </Container>

      <FooterWithFourColumns />
    </Box>
  );
};

export default LivePage;
